import React, { memo } from 'react';
import cls from './CharterItem.module.css';
import classNames from 'classnames';
import { ItemResizer } from '../ItemResizer/ItemResizer';
import { useResize } from '../../../hooks/useResize';
import { ItemMover } from '../ItemMover/ItemMover';
import { useMoveCharter } from '../../../hooks/useMoveCharter';
import { PlanFactCharterItem } from './PlanFactCharterItem';
import ReactTooltip from 'react-tooltip';
import { getFinalWidth } from '../../../helpers/getFinalWidth';
import { SmallMainElement } from '../SmallMainElement/SmallMainElement';
import { useSelector } from 'react-redux';

export const CharterItem = memo(({ charter, isPlanFact }) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const { positionX, handleMouseMove, handleMouseUp } = useMoveCharter(charter, activeTab);

    const { elWidth, changeWidth, onItemChange } = useResize(activeTab, charter);

    if (!charter) {
        return null;
    }

    let finalWidth = getFinalWidth(elWidth, activeTab);

    let isShowSmallMain = true;

    if (activeTab !== 'day') {
        if (activeTab === 'week' && elWidth < 11) {
            isShowSmallMain = false;
        }
        if (activeTab === 'month' && elWidth < 14) {
            isShowSmallMain = false;
        }
    }

    const isSmall = elWidth < 97;

    return (
        <>
            {isPlanFact ? (
                <PlanFactCharterItem charter={charter} />
            ) : (
                <div className={classNames(cls.wrapper)}>
                    <div
                        style={{ left: positionX }}
                        className={classNames(cls.charterItem, { [cls.planFact]: isPlanFact })}
                    >
                        {isShowSmallMain && (
                            <svg
                                width="12"
                                height="28"
                                viewBox="0 0 12 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0 4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V24C12 26.2091 10.2091 28 8 28H4C1.79086 28 0 26.2091 0 24V4Z"
                                    fill="#E6E6E6"
                                />
                                <path
                                    d="M12 6H8V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V23C4 23.5523 4.44772 24 5 24H7C7.55228 24 8 23.5523 8 23V22H12V24C12 26.2091 10.2091 28 8 28H4C1.79086 28 0 26.2091 0 24V4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V6Z"
                                    fill="#FFC62E"
                                />
                            </svg>
                        )}
                        <ItemMover onMove={handleMouseMove} onMouseUp={handleMouseUp}>
                            {/*<ReactTooltip*/}
                            {/*    id={`diagram-charter-${charter.guid}`}*/}
                            {/*    aria-haspopup="true"*/}
                            {/*    effect="solid"*/}
                            {/*    delayHide={200}*/}
                            {/*    delayShow={200}*/}
                            {/*    type="light"*/}
                            {/*    className={cls.tooltip}*/}
                            {/*>*/}
                            {/*    <p>{charter.name}</p>*/}
                            {/*</ReactTooltip>*/}
                            {!isShowSmallMain ? (
                                <div>
                                    <SmallMainElement
                                        daysCount={charter.planned.days_count}
                                        width={finalWidth}
                                        variant={'charter'}
                                        elWidth={elWidth}
                                        onResize={changeWidth}
                                        onStageChange={onItemChange}
                                        classes={cls.resizer}
                                    />
                                </div>
                            ) : (
                                <div
                                    title={charter.name}
                                    data-tip
                                    data-for={`diagram-charter-${charter.guid}`}
                                    className={classNames(cls.MainElement, {
                                        [cls.backgroundFact]: isPlanFact,
                                        [cls.small]: isSmall,
                                        [cls.notRightPadding]:
                                            (+charter.planned.days_count < 3 &&
                                                activeTab !== 'day') ||
                                            (elWidth < 22 && activeTab !== 'day'),
                                    })}
                                    style={{
                                        width: finalWidth,
                                    }}
                                >
                                    <span className={cls.text}>{charter?.name}</span>
                                </div>
                            )}
                        </ItemMover>

                        <div className={classNames(cls.resizerCharter)}>
                            {isShowSmallMain && (
                                <>
                                    <ItemResizer
                                        onResize={changeWidth}
                                        elWidth={elWidth}
                                        onStageChange={onItemChange}
                                        classes={cls.resizer}
                                    />
                                    <svg
                                        style={{
                                            marginLeft: `${
                                                charter.planned.days_count === '2' &&
                                                activeTab !== 'day'
                                                    ? '-2px'
                                                    : '-1px'
                                            }`,
                                            cursor: 'ew-resize',
                                        }}
                                        width="12"
                                        height="28"
                                        viewBox="0 0 12 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 4C12 1.79086 10.2091 0 8 0H4C1.7909 0 0 1.79086 0 4V24C0 26.2091 1.7909 28 4 28H8C10.2091 28 12 26.2091 12 24V4Z"
                                            fill="#E6E6E6"
                                        />
                                        <path
                                            d="M0 6H4V5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5V23C8 23.5523 7.55228 24 7 24H5C4.44772 24 4 23.5523 4 23V22H0V24C0 26.2091 1.79086 28 4 28H6H8C10.2091 28 12 26.2091 12 24V4C12 1.79086 10.2091 0 8 0H4C1.79086 0 0 1.79086 0 4V6Z"
                                            fill="#FFC62E"
                                        />
                                    </svg>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});
